define('bindingHandlers/dropdown',[
    'lib/lodash4',
    'lib/knockout',
    'jquery'
],
    function (_, ko, $) {
    'use strict';

    //Global Constants
    var EVENT_NAMESPACE = ".dropdown-event";
    var IS_OPEN_DOMDATA_KEY = "dropdown-isopen-domdata";

    /**
     * <p>Binding for dropdown interactions</p>
     * <p>
     * This binding opens and closes a dropdown menu bound
     * to a boolean observable. If the boolean is true, the
     * menu will be open. If false, it will be closed.
     *
     * If an observable is not provided, then one will be created,
     * using the provided value as its initial open/closed state.
     *
     * To autoclose the dropdown menu without explicitly maintaining
     * the isOpen observable in the viewModel, you may add an
     * attribute to any item with in the dropdown menu, such that
     * any clicks within that element will cause the dropdown to close.
     *
     * </p>
     * @exports bindingHandlers/dropdown
     */
    ko.bindingHandlers.dropdown = {
        init: function (element, valueAccessor) {
            var $dropdown = $(element);

            var isOpen = valueAccessor();
            //If they don't provide an observable to control the dropdown, create one
            if(!ko.isObservable(isOpen)) {
                isOpen = ko.observable(isOpen);
            }
            //Store the observable in domData so we can get it again in the update function
            ko.utils.domData.set(element, IS_OPEN_DOMDATA_KEY, isOpen);
            $dropdown.addClass('dropdown');
            var onDropdownClickHandler = function (event) {
                if ($(event.currentTarget).parent().is(element)) {
                    event.preventDefault();
                    isOpen(!isOpen());
                    var $menuItems = $dropdown.find('.dropdown-menu');
                    var $button = $dropdown.find('.dropdown-toggle');
                    $dropdown.removeClass('dropup');
                    if ( $menuItems.length && ( $menuItems.outerHeight() + $menuItems.offset().top + $button.outerHeight() ) >= ( $(window).scrollTop() + $(window).height() ) ) {
                        $dropdown.addClass('dropup');
                    }
                }
            };
            $dropdown.on('click'+EVENT_NAMESPACE, '.dropdown-toggle', onDropdownClickHandler);

            // We need to keep a close handler around so we can un-bind it from the
            // document root on a per binding basis.
            var modalCloseHandler = function (event) {
                var isInDropdown =  ($(event.target).closest(element).length > 0);
                var $dropdownAutoclose = $(event.target).closest($("[data-dropdown-autoclose]"));
                var isInDropdownAutoclose = $dropdownAutoclose.length > 0;
                var $disabled = $(event.target).closest($("[disabled]"));
                var isInDisabled = $disabled.closest(element).length > 0;

                if ( !isInDropdown || (isInDropdownAutoclose && !isInDisabled) ) {
                    isOpen(false);
                }
            };
            ko.utils.domData.set(element, 'dropdown-handlers', {
                modalCloseHandler: modalCloseHandler
            });

            //Clean up the binding handler when the element is removed from the DOM.
            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                $(element).off(EVENT_NAMESPACE, onDropdownClickHandler);
                $(document).off(EVENT_NAMESPACE, modalCloseHandler);
            });

        },
        update: function (element) {
            var modalCloseHandler = ko.utils.domData.get(element, 'dropdown-handlers').modalCloseHandler;

            var isOpen = ko.utils.domData.get(element, IS_OPEN_DOMDATA_KEY);
            if (isOpen()) {
                $(element).addClass('open');
                _.defer(function(){
                    $(document).on('click'+EVENT_NAMESPACE, modalCloseHandler);
                });
            } else {
                $(element).removeClass('open');
                $(document).off('click'+EVENT_NAMESPACE, modalCloseHandler);
            }
        }
    };
});

